<template>
  <BaseTemplate :currentUser="currentUser" :isTop="true">
    <div v-if="packList" class="top">
      <div class="pack_menu_list">
        <div class="pack_menu" :class="{ active: showCardType == 1 }" @click="selectPackType(1)">ポケモン</div>
        <div class="pack_menu" :class="{ active: showCardType == 2 }" @click="selectPackType(2)">ワンピース</div>
        <div class="border_style left">
          <div class="one"></div>
          <div class="two"></div>
        </div>
        <div class="border_style right">
          <div class="one"></div>
          <div class="two"></div>
        </div>
      </div>
      <div v-if="showCardType == 9999" class="comming_soon">comming soon</div>
      <div class="_pack_list" v-if="-1 == showCardType && showCardType != 11">
        <div class="post_list" v-for="(postItem, i) in postItemList" :key="i">
          <div class="title">
            <span>
              {{ postItem.title }}
            </span>
            <span>
              {{ postItem.name }}
            </span>
            <span>
              {{ postItem.created }}
            </span>
          </div>
          <div class="content">
            {{ postItem.content }}
          </div>
          <div class="images">
            <div class="image" v-for="(image, j) in postItem.images" :key="j">
              <img :src="image" alt="">
            </div>
          </div>
        </div>
        <BoxPager
          v-if="page && page.pages.length > 0"
          class="box-pager"
          :totalPageCount="page.all_page"
          :currentPageCount="page.page"
          :dispBoxCount="page.pages.length"
          :pages="page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
      <div class="_pack_list" v-for="(cardType, i) in cardTypeList" :key="i">
        <div class="product-list" v-if="cardType.id == showCardType">
          <ProductBanner v-for="(packItem) in productList[cardType.id]" :key="packItem.id" class="banner"
            :packItem="packItem" :currentUser="currentUser" @handleBannerClick="goToProductDetail"
            @handleLoginClick="goToLogin" />
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
// import ShadowButton from '@/components/molecules/ShadowButton.vue';
// import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';

export default {
  name: 'Top',

  components: {
    BaseTemplate,
    ProductBanner,
    // ShadowButton,
    // BlackGradationButton,
    BoxPager,
  },

  data: () => ({
    productList: [],
  }),
  mixins: [t],

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/cardTypeList',
      showCardType: 'pack/topCardType',
      postList: 'post/postList',
      page: 'post/page',
    }),
    postItemList() {
      if (this.postList.list) {
        const formattedItemList = this.postList.list.map((item) => (
          {
            ...item,
            name:
              process.env.VUE_APP_LANG_MODE === 'en' ? `${item.lastName} ${item.middleName} ${item.firstName}` : `${item.lastName} ${item.firstName}`,
          }
        ), []);
        return formattedItemList;
      }
      return [];
    },
  },

  watch: {
    packList(newList) {
      for (let i = 0; i < newList.list.length; i += 1) {
        const idx = newList.list[i].card_type;
        if (!this.productList[idx]) {
          this.productList[idx] = [];
        }
        this.productList[idx].push(newList.list[i]);
      }
    },
  },

  created() {
    this.$store.dispatch('pack/setPackList');
    this.$store.dispatch('cardType/setCardTypeList');
    // this.$store.dispatch('post/getPostList', { pageNumber: 1 });
  },

  methods: {
    goToProductDetail(packId, num) {
      if (num) {
        this.$router.push({ path: '/pack-detail', query: { packId, num } });
      } else {
        this.$router.push({ path: '/pack-detail', query: { packId } });
      }
    },
    goToLogin() {
      this.$router.push({ path: '/login' });
    },
    goToSpecificCommerce() {
      // this.$router.push('/specific-commerce');
      window.open('/notation/', '_blank');
    },
    goToTermsOfService() {
      // this.$router.push('/terms-of-service');
      window.open('/terms/', '_blank');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      // this.$router.push('/user-guide');
      window.open('/user-guide/', '_blank');
    },
    moveList(index) {
      this.$router.push({ path: '/pack-list', query: { index } });
    },
    goMyPage() {
      if (this.currentUser.is_login === '1') {
        this.$router.push('/my-page');
      } else {
        this.$router.push('/login');
      }
    },
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
    changeCurrentPageCount(pageNumber) {
      this.$store.dispatch('post/getPostList', { pageNumber });
    },
  },
};
</script>

<style lang="scss" scoped>
// ._pack_list {
//   margin-bottom: 50px;
//   .banner_list {
//     position: relative;
//     ._title {
//       color: $white;
//       text-align: center;
//       font-size: 24px;
//       font-weight: bold;
//     }
//     .list_button {
//       border-radius: 5px;
//       position: absolute;
//       right: 0;
//       top: 0;
//     }
//   }
// }
.over_message {
  text-align: center;
  margin-bottom: 30px;

  a {
    color: $black !important;
    text-decoration: none;

    span {
      color: $yellow;
    }
  }
}
.top {
  width: 100%;
  min-height: 100%;
  margin: 0 auto;

  .minny_link {
    text-align: center;
  }

  .pack_menu_list {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $white;
    // background: linear-gradient(to bottom, $white, $gray);
    border-bottom: solid 4px #ef5656;
    margin: 20px 0;
    // overflow-x: auto;
    flex-wrap: wrap;
    position: relative;

    .pack_menu {
      color: $gray;
      width: 40%;
      min-width: 40%;
      height: 46px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: .4s;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      border-left: solid 1px $gray;
      border-right: solid 1px $gray;
      border-top: solid 1px $gray;

      &:hover {
        background-color: #ef5656;
        color: $white;
      }

      &.active {
        background-color: #ef5656;
        border-left: solid 1px #ef5656;
        border-right: solid 1px #ef5656;
        border-top: solid 1px #ef5656;
        color: $white;
      }
      &:first-child {
        margin-right: 10px;
      }
    }
    .border_style {
      position: absolute;
      bottom: -4px;
      display: flex;
      div {
        width: 6px;
        height: 4px;
      }
      &.left {
        left: 0;
        .one {
          background-color: #49ba86;
        }
        .two {
          background-color: #25c4e8;
        }
      }
      &.right {
        right: 0;
        .one {
          background-color: #f7d50b;
        }
        .two {
          background-color: #49ba86;
        }
      }
    }
  }

  ._pack_list {
    margin: 0 auto 0 auto;
    // max-width: 1220px;
    max-width: 80%;

    .banner_list {
      position: relative;

      ._title {
        color: $white;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
      }

      .list_button {
        border-radius: 5px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  .product-list {
    display: flex;
    padding-bottom: 10px;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .banner {
    margin-bottom: 20px;
  }
  ._pack_list {
    .post_list {
      margin-top: 10px;
      .images {
        width: 100%;
        display: flex;
        .image {
          width: 25%;
          padding: 5px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .top {
    .pack_menu_list {
      .pack_menu {
        height: 40px;
        font-size: 16px;
        width: 46%;
        &:first-child {
          margin-right: 4px;
        }
      }
    }
    ._pack_list {
      max-width: 90%;
    }
  }

  .over_message {
    margin-bottom: 20px;
  }
}

.comming_soon {
  text-align: center;
  margin-top: 40px;
  font-size: 24px;
  color: $black;
}
</style>

<style lang="scss">
html, body {
  overflow-x: hidden;
}
</style>
